import Service from './Service';

/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class TipoJulgamentoService extends Service {
    async recuperarTiposJulgamento() {
        return this.getTipoJulgamentoApi().recuperarTiposJulgamento();
    }
}

export default TipoJulgamentoService;
